export const adminHeaders = (session, extra = {}) => ({
    Authorization: session?.accessToken,
    'Vendor-Id': session?.vendorId,
    ...extra,
});
